export default __webpack_public_path__ + "static/media/amazon-music.7e46a2f1.svg";